// Mock data for Knowledge Ninja Lab website

export const mockServices = [
  {
    id: 0,
    title: "Market Research & Business Intelligence",
    description: "Comprehensive competitor analysis and market insights",
    duration: "2-4 weeks",
    price: "$2,500 - $10,000"
  },
  {
    id: 1,
    title: "Student Support & Mentorship",
    description: "Academic guidance and presentation coaching",
    duration: "Ongoing",
    price: "$50 - $200/hour"
  },
  {
    id: 2,
    title: "Business Cases & Corporate Presentations",
    description: "Professional strategy decks and visual storytelling",
    duration: "1-3 weeks",
    price: "$1,500 - $5,000"
  },
  {
    id: 3,
    title: "Startup Pitch Decks",
    description: "Investor-ready presentations with market validation",
    duration: "2-3 weeks",
    price: "$3,000 - $8,000"
  },
  {
    id: 4,
    title: "Consulting & AI Roadmaps",
    description: "Strategic growth advisory and technology integration",
    duration: "4-8 weeks",
    price: "$5,000 - $25,000"
  },
  {
    id: 5,
    title: "Artificial Intelligence Project",
    description: "Custom AI solutions and implementation",
    duration: "6-12 weeks",
    price: "$10,000 - $50,000"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    title: "Startup Founder",
    company: "TechVenture Inc.",
    content: "Knowledge Ninja Lab helped us create an outstanding pitch deck that secured $2M in Series A funding. Their market research was thorough and their presentation skills are exceptional.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b408?w=64&h=64&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    title: "MBA Student",
    company: "IIM Bangalore",
    content: "The mentorship I received was invaluable. They helped me excel in case studies and presentations, which significantly boosted my academic performance and confidence.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=64&h=64&fit=crop&crop=face"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    title: "Marketing Director",
    company: "GlobalCorp Ltd.",
    content: "Their business intelligence reports gave us the strategic edge we needed to outperform competitors. The insights were actionable and led to a 35% increase in market share.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=64&h=64&fit=crop&crop=face"
  }
];

export const mockTeamMembers = [
  {
    id: 1,
    name: "Dr. Priya Sharma",
    title: "Lead Consultant & Strategy Expert",
    education: "IIT Delhi, PhD in Business Analytics",
    experience: "10+ years in Fortune 500 consulting",
    specialization: "Market Research & AI Strategy",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=256&h=256&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "Vikram Patel",
    title: "Senior Research Analyst",
    education: "IIT Bombay, MS in Data Science",
    experience: "8+ years in business intelligence",
    specialization: "Data Analytics & Business Research",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=256&h=256&fit=crop&crop=face"
  },
  {
    id: 3,
    name: "Ananya Singh",
    title: "Presentation & Communication Specialist",
    education: "IIT Kharagpur, MBA in Marketing",
    experience: "6+ years in corporate training",
    specialization: "Presentation Design & Student Mentorship",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=256&h=256&fit=crop&crop=face"
  }
];

export const mockBookingSlots = [
  {
    date: "2025-01-15",
    slots: ["10:00 AM", "2:00 PM", "4:00 PM"]
  },
  {
    date: "2025-01-16",
    slots: ["9:00 AM", "11:00 AM", "3:00 PM"]
  },
  {
    date: "2025-01-17",
    slots: ["10:00 AM", "1:00 PM", "5:00 PM"]
  }
];

export const mockChatResponses = {
  greeting: "Hi! I'm the Knowledge Ninja assistant. How can I help you today?",
  services: "We offer Market Research, Student Mentorship, Business Cases, Pitch Decks, AI Consulting, and more. Which service interests you?",
  booking: "I'd be happy to help you book a consultation. Let me redirect you to our booking form.",
  pricing: "Our pricing varies by service complexity. Market Research starts at $2,500, Student Mentorship at $50/hour, and custom AI projects from $10,000. Would you like specific pricing for a particular service?",
  contact: "You can reach us at info.knowledgeninjalab@gmail.com or call +91 9266849651. We're also on LinkedIn and Medium!",
  default: "I'd be happy to help! You can ask me about our services, pricing, or book a consultation. What would you like to know?"
};

// Simulate form submission
export const mockFormSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock form submission:', formData);
      resolve({
        success: true,
        message: "Thank you for your inquiry! We'll get back to you within 24 hours.",
        confirmationId: `KNL-${Date.now()}`
      });
    }, 1500);
  });
};

// Simulate chatbot responses
export const mockChatbotResponse = (message) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const lowerMessage = message.toLowerCase();
      let response;
      
      if (lowerMessage.includes('service') || lowerMessage.includes('what do you do')) {
        response = mockChatResponses.services;
      } else if (lowerMessage.includes('book') || lowerMessage.includes('appointment')) {
        response = mockChatResponses.booking;
      } else if (lowerMessage.includes('price') || lowerMessage.includes('cost')) {
        response = mockChatResponses.pricing;
      } else if (lowerMessage.includes('contact') || lowerMessage.includes('reach')) {
        response = mockChatResponses.contact;
      } else {
        response = mockChatResponses.default;
      }
      
      resolve(response);
    }, 800);
  });
};